'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import parse from 'html-react-parser';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BsGeoAltFill } from 'react-icons/bs';
import { useInView } from 'react-intersection-observer';
import ListingCard from '@/features/listing/components/listing-card/listing-card';
import ListingMessageButton from '@/features/listing/components/listing-card/listing-message/listing-message-button';
import ListingMoveInDate from '@/features/listing/components/listing-card/listing-move-in-date/listing-move-in-date';
import ListingRate from '@/features/listing/components/listing-card/listing-rate/listing-rate';
import ListingUser from '@/features/listing/components/listing-card/listing-user/listing-user';
import ListingVerifications from '@/features/listing/components/listing-card/listing-verifications/listing-verifications';
import ListingDetailGallery from '@/features/listing/components/listing-detailed/listing-detail-gallery/listing-detail-gallery';
import ListingDetailMap from '@/features/listing/components/listing-detailed/listing-detail-map/listing-detail-map';
import ListingDetailRoomInfo from '@/features/listing/components/listing-detailed/listing-detail-room-info/listing-detail-room-info';
import ListingDetailActions from '@/features/listing/components/listing-detailed/listings-detail-actions/listing-detail-actions';
import ListingMessage from '@/features/listing/components/listing-message/listing-message';
import ListingReportModal from '@/features/listing/components/listing-report-modal/listing-report-modal';
import { DEFAULT_LISTING_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import { type ListingType, ListingTypeId, type ListingWithUser } from '@/features/listing/types/listing-types';
import { type UserListingsData } from '@/features/listing/types/user-listings-types';
import placeNameToUrl from '@/features/place/utils/place-name-to-url';
import useAppFlyerLink from '@/features/roomster-app/hooks/use-app-flyer-link';
import { Link } from '@/i18n/routing';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import Button from '@/ui/button/button';
import styles from './listing-detailed.module.scss';
interface ListingDetailedComponentProps {
  listing: ListingWithUser;
  userListings?: UserListingsData | null;
}
export default function ListingDetailed(props) {
  const $ = _c(130);
  const {
    listing,
    userListings
  } = props;
  let t0;
  if ($[0] !== listing.id) {
    t0 = () => {
      const windowPathname = globalThis.location.pathname;
      const windowCurrentId = windowPathname.split("/listings/")[1];
      if (windowCurrentId !== String(listing.id)) {
        const updatedPathName = windowPathname.replace(String(windowCurrentId), String(listing.id));
        globalThis.history.pushState({}, "", updatedPathName);
      }
    };
    $[0] = listing.id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const updateUrl = t0;
  let t1;
  if ($[2] !== updateUrl) {
    t1 = {
      onChange: inView => {
        if (inView) {
          updateUrl();
        }
      },
      threshold: 0.3
    };
    $[2] = updateUrl;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [markerRef] = useInView(t1);
  const listingType = ListingTypeId[listing.listingTypeId] as ListingType;
  const isListingPerson = listingType === "needapartment" || listingType === "needroom";
  const listingUrlPart = DEFAULT_LISTING_PART_VARIANTS[listingType];
  const listingDetailTranslations = useTranslations("listing.detail");
  let otherUserListings = [];
  if (userListings) {
    let t2;
    if ($[4] !== listing.id) {
      t2 = userListing => userListing.id !== listing.id;
      $[4] = listing.id;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    otherUserListings = userListings.listings.filter(t2);
  }
  const [isReportModalShow, setIsReportModalShow] = useState(false);
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsReportModalShow(false);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleReportModalClose = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsReportModalShow(true);
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleShowReportModal = t3;
  const profileAppFlyerLink = useAppFlyerLink("mobile", "mobileListingUserAvatar", `/profile/${String(listing.user.id)}/listings`);
  const t4 = styles;
  let t5;
  if ($[8] !== listing.id || $[9] !== listing.images || $[10] !== listing.isBookmarked || $[11] !== listing.isNew || $[12] !== listing.refreshed || $[13] !== listing.title || $[14] !== listingType) {
    t5 = <div className={styles.listingDetailed_gallery}><ListingDetailGallery images={listing.images} alt={listing.title} listingId={listing.id} isBookmarked={listing.isBookmarked} isNew={listing.isNew} listingRefreshedDate={listing.refreshed} listingType={listingType} /></div>;
    $[8] = listing.id;
    $[9] = listing.images;
    $[10] = listing.isBookmarked;
    $[11] = listing.isNew;
    $[12] = listing.refreshed;
    $[13] = listing.title;
    $[14] = listingType;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== listing.title) {
    t6 = <h1 className={styles.listingDetailed_title}>{listing.title}</h1>;
    $[16] = listing.title;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cx(styles.listingDetailed_info, styles.listingDetailed_box);
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== listingDetailTranslations) {
    t8 = listingDetailTranslations("info.price-month");
    $[19] = listingDetailTranslations;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t8) {
    t9 = <p className={styles.listingDetailed_infoTitle}>{t8}</p>;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== listing.rates) {
    t10 = <div><ListingRate rate={listing.rates} view="isDetailed" /></div>;
    $[23] = listing.rates;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = <div className={styles.listingDetailed_infoItem}>{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== listingDetailTranslations) {
    t12 = listingDetailTranslations("info.listing-type");
    $[28] = listingDetailTranslations;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = <p className={styles.listingDetailed_infoTitle}>{t12}</p>;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const t14 = `info.listing-type-value.${listingType}`;
  let t15;
  if ($[32] !== listingDetailTranslations || $[33] !== t14) {
    t15 = listingDetailTranslations(t14);
    $[32] = listingDetailTranslations;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15) {
    t16 = <div>{t15}</div>;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t13 || $[38] !== t16) {
    t17 = <div className={styles.listingDetailed_infoItem}>{t13}{t16}</div>;
    $[37] = t13;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== isListingPerson || $[41] !== listing.calendar.dateIn) {
    t18 = <div className={styles.listingDetailed_infoItem}><ListingMoveInDate moveInDate={listing.calendar.dateIn} view="isDetailed" isListingPerson={isListingPerson} /></div>;
    $[40] = isListingPerson;
    $[41] = listing.calendar.dateIn;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t11 || $[44] !== t17 || $[45] !== t18) {
    t19 = <div className={t7}>{t11}{t17}{t18}</div>;
    $[43] = t11;
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== listing.addressVerificationStatus || $[48] !== listing.user.verifications) {
    t20 = <div className={styles.listingDetailed_box}><ListingVerifications isAddressVerified={listing.addressVerificationStatus} userVerifications={listing.user.verifications} /></div>;
    $[47] = listing.addressVerificationStatus;
    $[48] = listing.user.verifications;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== isListingPerson || $[51] !== listing.addressFormatted || $[52] !== listing.geoLocation || $[53] !== listingUrlPart) {
    t21 = !isListingPerson && <div className={styles.listingDetailed_box}><Link className={styles.listingDetailed_geoAddress} href={ROUTER_LINKS.searchResults(listingUrlPart, placeNameToUrl(listing.addressFormatted))}><BsGeoAltFill className={styles.listingDetailed_addressIcon} /><p>{listing.addressFormatted}</p></Link><ListingDetailMap coordinates={{
        lat: listing.geoLocation.latitude,
        lng: listing.geoLocation.longitude
      }} /></div>;
    $[50] = isListingPerson;
    $[51] = listing.addressFormatted;
    $[52] = listing.geoLocation;
    $[53] = listingUrlPart;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== listingDetailTranslations) {
    t22 = listingDetailTranslations("description");
    $[55] = listingDetailTranslations;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t22) {
    t23 = <p className={styles.listingDetailed_descriptionTitle}>{t22}</p>;
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== listing.description) {
    t24 = parse(listing.description.replaceAll(/\r\n|\r|\n/g, "<br />"));
    $[59] = listing.description;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== t24) {
    t25 = <p className={styles.listingDetailed_descriptionText}>{t24}</p>;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== t23 || $[64] !== t25) {
    t26 = <div className={styles.listingDetailed_box}>{t23}{t25}</div>;
    $[63] = t23;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== listing.detailsApartment || $[67] !== listing.detailsRoom) {
    t27 = (listing.detailsRoom ?? listing.detailsApartment) && <ListingDetailRoomInfo detailsRoom={listing.detailsRoom} detailsApartment={listing.detailsApartment} />;
    $[66] = listing.detailsApartment;
    $[67] = listing.detailsRoom;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== t19 || $[70] !== t20 || $[71] !== t21 || $[72] !== t26 || $[73] !== t27) {
    t28 = <div className={styles.listingDetailed_content}>{t19}{t20}{t21}{t26}{t27}</div>;
    $[69] = t19;
    $[70] = t20;
    $[71] = t21;
    $[72] = t26;
    $[73] = t27;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = cx(styles.listingDetailed_user, styles.listingDetailed_box);
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  const t30 = `${ROUTER_LINKS.profile}/${String(listing.user.id)}`;
  let t31;
  if ($[76] !== listing.user) {
    t31 = <ListingUser user={listing.user} />;
    $[76] = listing.user;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  let t32;
  if ($[78] !== t30 || $[79] !== t31) {
    t32 = <Link prefetch={false} href={t30}>{t31}</Link>;
    $[78] = t30;
    $[79] = t31;
    $[80] = t32;
  } else {
    t32 = $[80];
  }
  let t33;
  if ($[81] !== listing) {
    t33 = <ListingMessage listing={listing} view="isDetailed" messageSrc="listingprofile" />;
    $[81] = listing;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== t32 || $[84] !== t33) {
    t34 = <div className={t29}>{t32}{t33}</div>;
    $[83] = t32;
    $[84] = t33;
    $[85] = t34;
  } else {
    t34 = $[85];
  }
  let t35;
  if ($[86] !== handleShowReportModal || $[87] !== listing.id || $[88] !== listing.isBookmarked || $[89] !== listingType) {
    t35 = <ListingDetailActions listingId={listing.id} isBookmarked={listing.isBookmarked} listingType={listingType} onReportClick={handleShowReportModal} />;
    $[86] = handleShowReportModal;
    $[87] = listing.id;
    $[88] = listing.isBookmarked;
    $[89] = listingType;
    $[90] = t35;
  } else {
    t35 = $[90];
  }
  let t36;
  if ($[91] !== t34 || $[92] !== t35) {
    t36 = <div className={styles.listingDetailed_sidebar}>{t34}{t35}</div>;
    $[91] = t34;
    $[92] = t35;
    $[93] = t36;
  } else {
    t36 = $[93];
  }
  let t37;
  if ($[94] !== t28 || $[95] !== t36 || $[96] !== t5 || $[97] !== t6) {
    t37 = <div className={styles.listingDetailed_body}>{t5}{t6}{t28}{t36}</div>;
    $[94] = t28;
    $[95] = t36;
    $[96] = t5;
    $[97] = t6;
    $[98] = t37;
  } else {
    t37 = $[98];
  }
  const t38 = otherUserListings.length > 0 && userListings && <div className={cx(styles.listingDetailed_listings, styles.listingDetailed_box)}><div className={styles.listingDetailed_listingsTitle}><h3>{listingDetailTranslations("other-listings-from")} {listing.user.firstName}</h3>{otherUserListings.length > 2 && <div className={styles.listingDetailed_listingsButton}><Button href={`/profile/${String(listing.user.id)}/listings`} element="link" size="lg" fontSize="s" fullWidth={true}>{listingDetailTranslations("user-listings-count", {
            count: userListings.count
          })}</Button></div>}</div><div className={styles.listingDetailed_listingsList}>{otherUserListings.map((userListing_0, index) => {
        const listingWithUser = {
          ...userListing_0,
          user: listing.user
        };
        return <div key={userListing_0.id} className={cx(styles.listingDetailed_listingCard, index > 1 && styles.listingDetailed_listingCard__withFade)}><ListingCard listing={listingWithUser} showMessageButton={false} /></div>;
      })}</div></div>;
  let t39;
  if ($[99] !== handleReportModalClose || $[100] !== isReportModalShow || $[101] !== listing.id || $[102] !== listing.user.id) {
    t39 = isReportModalShow && <ListingReportModal listingId={listing.id} userId={listing.user.id} isActive={isReportModalShow} onClose={handleReportModalClose} />;
    $[99] = handleReportModalClose;
    $[100] = isReportModalShow;
    $[101] = listing.id;
    $[102] = listing.user.id;
    $[103] = t39;
  } else {
    t39 = $[103];
  }
  let t40;
  if ($[104] !== markerRef || $[105] !== t37 || $[106] !== t38 || $[107] !== t39 || $[108] !== t4.listingDetailed) {
    t40 = <section ref={markerRef} className={t4.listingDetailed}>{t37}{t38}{t39}</section>;
    $[104] = markerRef;
    $[105] = t37;
    $[106] = t38;
    $[107] = t39;
    $[108] = t4.listingDetailed;
    $[109] = t40;
  } else {
    t40 = $[109];
  }
  let t41;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = {
      lineHeight: "0"
    };
    $[110] = t41;
  } else {
    t41 = $[110];
  }
  let t42;
  if ($[111] !== listing.user) {
    t42 = <ListingUser user={listing.user} view="isDetailed" />;
    $[111] = listing.user;
    $[112] = t42;
  } else {
    t42 = $[112];
  }
  let t43;
  if ($[113] !== profileAppFlyerLink || $[114] !== t42) {
    t43 = <Link prefetch={false} target="_blank" href={profileAppFlyerLink} style={t41}>{t42}</Link>;
    $[113] = profileAppFlyerLink;
    $[114] = t42;
    $[115] = t43;
  } else {
    t43 = $[115];
  }
  let t44;
  if ($[116] !== handleShowReportModal || $[117] !== listing.id || $[118] !== listing.isBookmarked || $[119] !== listingType) {
    t44 = <ListingDetailActions listingId={listing.id} isBookmarked={listing.isBookmarked} listingType={listingType} onReportClick={handleShowReportModal} />;
    $[116] = handleShowReportModal;
    $[117] = listing.id;
    $[118] = listing.isBookmarked;
    $[119] = listingType;
    $[120] = t44;
  } else {
    t44 = $[120];
  }
  let t45;
  if ($[121] !== listing) {
    t45 = <div className={styles.listingDetailed_messageButton}><ListingMessageButton listing={listing} view="isDetailed" messageSrc="listingprofile" /></div>;
    $[121] = listing;
    $[122] = t45;
  } else {
    t45 = $[122];
  }
  let t46;
  if ($[123] !== t43 || $[124] !== t44 || $[125] !== t45) {
    t46 = <div className={styles.listingDetailed_mobileBar}>{t43}{t44}{t45}</div>;
    $[123] = t43;
    $[124] = t44;
    $[125] = t45;
    $[126] = t46;
  } else {
    t46 = $[126];
  }
  let t47;
  if ($[127] !== t40 || $[128] !== t46) {
    t47 = <>{t40}{t46}</>;
    $[127] = t40;
    $[128] = t46;
    $[129] = t47;
  } else {
    t47 = $[129];
  }
  return t47;
}